import { Component } from "@angular/core";
import { mdlPayloadRequest } from "../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../Models/mdlPayloadResponse";
import { motorProposalService } from "../../Services/motorProposalService";
import { mdlRenewalPoliciesListRes, mdlRenewalPolicies } from "../../Models/mdlRenewalPolicies";
import Swal from 'sweetalert2';
import { Router } from "@angular/router";
import { userService } from "../../Services/userService";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { restURL } from "../../Models/restURL";
import { RegModel } from "../../Models/RegModel";
import { AddNewPolicyReqMdl } from "../../Models/AddNewPolicyReqMdl";
import { LanguageService } from "../../Services/languageService";
import { Subscription } from 'rxjs';

@Component({
    selector: 'RenewalPolicies',
    templateUrl: './RenewalPolicies.html',
    styleUrls: ['./RenewalPolicies.css']
})
export class RenewalPolicies {
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
    public objRPListRes: mdlRenewalPoliciesListRes = new mdlRenewalPoliciesListRes();
    public objRPList: Array<mdlRenewalPolicies> = new Array<mdlRenewalPolicies>();
    public CurrentPolicy: mdlRenewalPolicies = new mdlRenewalPolicies();
    public regObj: RegModel = new RegModel();
    public isShowLoading: boolean;
    public newPolicyReq: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
    public newPolicyRes: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
    public Lng: string = "en";
    public LngSubscription: Subscription;

    constructor(private lngService: LanguageService, private http: HttpClient, private url: restURL, private translate: TranslateService, private userinfo: userService, private router: Router, private EncriptService: motorProposalService) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        this.GetRenewalPoliciesList();
    }

    GetRenewalPoliciesList() {
        this.regObj.RegNo = sessionStorage.getItem("RegNo");
        this.regObj.token = sessionStorage.getItem("token");
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));

        this.isShowLoading = true;
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/GetRenewalPoliciesList", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise()
            .then((result) => {
                this.isShowLoading = false;
                this.objPayloadResponse = result;
                this.objRPListRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                if (this.objRPListRes.RegNo != Number(sessionStorage.getItem("RegNo"))) {
                    Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
                    this.router.navigate(['BeforeLogin/NewReg']);
                    return;
                }
                if (this.objRPListRes.StatusCode == "F") {
                    Swal(this.translate.instant(this.objRPListRes.StatusDesc));
                    return;
                }
                this.objRPList = this.objRPListRes.RenewalPoliciesList;
            }, (error) => {
                this.isShowLoading = false;
                this.userinfo.checkTokenStatus(error);
            });
    }

    goForRenew1(policy) {
        this.CurrentPolicy = policy;
        sessionStorage.setItem("RenewalPolicy", this.EncriptService.EncriptObject(JSON.stringify(this.CurrentPolicy)));
        this.router.navigate(['/NewDashboard/CompRenewalPolicy']);
    }



    goForRenew(policy) {
        this.newPolicyReq.RegNo = sessionStorage.getItem("RegNo");
        this.newPolicyReq.InsuredToken = sessionStorage.getItem("InsuredToken");
        this.newPolicyReq.productType = policy.ProductCode;
        this.newPolicyReq.VDT=policy.VehicleDefType;
        this.newPolicyReq.IqamaNoforDis=policy.InsuredIdNo;
        this.newPolicyReq.IqamaNo=policy.InsuredIdNo;
        this.newPolicyReq.SequenceNo = policy.VehicleSequenceNo;
        this.newPolicyReq.CustomID=policy.VehicleCustomId;
        this.newPolicyReq.VehicleModelYear=policy.VehicleModelYear;
        this.newPolicyReq.IsRenewal=true;
        this.newPolicyReq.PrvPolicyNo=policy.PolicyNo;
        
        sessionStorage.removeItem("mp");
        this.isShowLoading = true;
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.newPolicyReq));

        //this.http.post<AddNewPolicyReqMdl>(this.apiUrl.baseURL+"newPolicy/addNewPolicy",this.newPolicyReq,this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "newPolicy/addNewPolicy", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                //this.newPolicyRes=result;

                //New Line Start
                this.objPayloadResponse = result;
                let objResObj: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
                objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                if (objResObj.RegNo != this.newPolicyReq.RegNo) {
                    Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
                    this.router.navigate(['BeforeLogin/NewReg']);
                    return;
                }
                this.newPolicyRes = objResObj;
                //NewLine End

                if (this.newPolicyRes.st.StatusCode === "S") {
                    this.newPolicyRes.productType=policy.ProductCode;

                    
                    sessionStorage.setItem("newPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(this.newPolicyRes)));
                    sessionStorage.setItem("CurrentRoute", "InsuredInfo");
                    this.router.navigate(['./NewDashboard/MotorProposalForm/InsuredInfo']);

                } else {
                    if (this.newPolicyRes.st.StatusCode == "F" && this.newPolicyRes.st.StatusDesc == "You can't proceed because not registered in Saudi post address") {
                        if (this.Lng == "en") {
                            let stHTML: string;
                            stHTML = "<p style='font-size:16px;'>Dear customer Please register or update your own National Address: <a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
                            Swal({
                                title: '',
                                html: stHTML,
                                type: "info",
                                width: '50%',
                            });
                        } else {
                            let stHTML: string;
                            stHTML = "<p style='font-size:16px;'>عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي<a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
                            Swal({
                                title: '',
                                html: stHTML,
                                type: "info",
                                width: '50%',
                            });
                        }

                    } else {

                        Swal(this.translate.instant(this.newPolicyRes.st.StatusDesc))

                    }

                }
            }, (error) => {
                this.isShowLoading = false;
                this.userinfo.checkTokenStatus(error);
            });
    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/RenewalPolicies/RenewalPolicies.ts